import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service'; 
@Component({
  selector: 'app-top-universities-for-bba-programs',
  templateUrl: './top-universities-for-bba-programs.component.html',
  styleUrls: ['./top-universities-for-bba-programs.component.scss']
})
export class TopUniversitiesForBbaProgramsComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;


  ngOnInit(): void {
  }

}
